/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { Alert } from "@mui/material";
import { Loader } from "../loader";

export const EmptyFilteredState = ({
  showInitialLoader,
  showResetAlert,
  debouncedSearchTerm,
  applyFilters,
  emptyFilterLabel,
  children,
  emptyTable,
}) => {
  if (showResetAlert && !debouncedSearchTerm) {
    return (
      <div>
        <Alert severity="info">{emptyFilterLabel}</Alert>
      </div>
    );
  }

  if (showInitialLoader) {
    return <Loader />;
  }

  if (children) {
    return <>{children}</>;
  }

  if (applyFilters) {
    return <>{emptyTable}</>;
  }

  return (
    <div>
      <Alert severity="info">{emptyFilterLabel}</Alert>
    </div>
  );
};
